// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__vAbKj","topBottomGutter":"Layout_topBottomGutter__2v8tl"};